export const rawToJSON = data => {
  const content = data ? JSON.parse(data) : null
  return content || {}
}
